<template>
    <div>
        <el-dialog title="机审条件" :visible.sync="show" width="20%" :before-close="handleClose">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm"
                    style="margin: auto;">
                    <!-- <el-form-item label="机审条件:">
                        <el-radio-group v-model="ruleForm.type" size="medium">
                            <el-radio :label="1">布尔-法院风险</el-radio>
                            <el-radio :label="2">新颜-贷超黑名单</el-radio>
                            <el-radio :label="3">百融-要素检查不通过</el-radio>
                            <el-radio :label="4">征信-逾期次数大于30天</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item label="布尔-法院风险：">
                        <el-radio-group v-model="ruleForm.a">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="新颜-贷超黑名单：">
                        <el-radio-group v-model="ruleForm.b">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="百融-要素检查不通过：">
                        <el-radio-group v-model="ruleForm.c">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="征信-逾期次数大于30天：">
                        <el-radio-group v-model="ruleForm.d">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        showJS: {
            type: Boolean,
            default: false
        },

    },
    watch: {
        showJS: {
            handler: function (newVal, oldVal) {
                this.show = newVal;
            },
            deep: true
        }
    },
    data() {
        return {
            show: false,
            ruleForm: {
                type: '',
            },
            rules: {
                type: [
                    { required: true, message: '请输入机审条件', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        submit() {

            let _this = this;
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    _this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    _this.$emit('refshPage');
                    _this.handleClose();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },



        handleClose() {
            // this.ruleForm.num = '';

            this.$refs.ruleForm.resetFields();
            this.$emit('close', false);
        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/order/order/dialog/machineReview.vue